// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KLgp","colMin":"styles_colMin__2v-Xq"};